import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, fontSizes, lineHeights, media, radii, space } = theme

export const Section = styled.section`
  box-sizing: border-box;
  width: 100%;
  padding: ${space['spacing-xxxl']} 0;
  background-color: ${colors['neutral-background-default']};

  @media (${media.tablet}) {
    padding: ${space['spacing-giga']} 0;
  }
`

export const Banner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xl']};
  background-color: ${colors['neutral-background-default']};

  .ds-button {
    display: flex;
    justify-content: center;
    width: 100%;
    height: ${space['spacing-mega']};
    border-radius: ${radii['corner-radius-pill']};
  }

  @media (${media.tablet}) {
    flex-direction: row;
    gap: ${space['spacing-xl']};
    align-items: center;
    padding: ${space['spacing-xl']};
    border-radius: 26px;
    background-color: ${colors['cashme-dark-blue']};

    .ds-button {
      flex: 0 0 auto;
      gap: ${space['spacing-sm']};
      width: auto;
      min-width: 230px;
      padding-right: ${space['spacing-lg']};
      padding-left: ${space['spacing-lg']};
    }
  }
`

export const PolygonWrapper = styled.span`
  display: inline-flex;
  width: 33px;
  height: 40px;

  @media (${media.tablet}) {
    position: absolute;
    top: ${space['spacing-xl']};
    left: -17px;
  }
`

export const Copy = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${space['spacing-sm']};

  h2,
  p {
    margin: 0;
    color: ${colors['neutral-text-default']};
  }

  h2 {
    font-size: ${fontSizes['font-size-mobile-heading-3']};
    line-height: ${lineHeights['font-line-height-md']};
  }

  p {
    line-height: ${lineHeights['font-line-height-lg']};
  }

  @media (${media.tablet}) {
    padding-left: ${space['spacing-md']};

    h2,
    p {
      color: ${colors['neutral-text-contrast-default']};
    }

    h2 {
      font-size: ${fontSizes['font-size-heading-3']};
    }
  }
`
